import React, { FC } from 'react';
import { KeyValueTable } from '../../../../../../components/atoms';
import { PlannedTwinID } from '../../../../../../config/types';
import { getContextStores } from '../../../../../../context';
import { getAssetStatusesKeyedById } from '../../../../../../selectors';
import { displayDateInProjectTime } from '../../../../../../utils';

interface Props {
  record: PlannedTwinID
}

const PlannedTwinIDPropertiesSubTable: FC<Props> = ({ record }) => {
  const contextStores = getContextStores();

  /* Selectors */
  const statusesKeyedById = getAssetStatusesKeyedById(contextStores);
  const data = [
    {
      key: 'twinID',
      value: record.twinID,
    },
    {
      key: 'sequence',
      value: `${record.sequence}`,
    },
    ...Object.keys(record.plannedStatusDates)
      .map(k => ({
        key: statusesKeyedById.get(k)?.label ?? k,
        value: displayDateInProjectTime(record.plannedStatusDates[k]),
      })),
  ];
  return (
    <KeyValueTable
      data={data}
    />
  );
};

export default PlannedTwinIDPropertiesSubTable;
